const de = {
  man: 'Mann',
  woman: 'Frau',
  men: 'Männer',
  women: 'Frauen',
  men_gen: 'Männern',
  women_gen: 'Frauen',
  header: {
    title: 'Wie gross sind Sie im Vergleich?',
    lead: 'Wie viele Menschen in der Schweiz sind grösser als Sie, wie viele kleiner? Und wie war das vor 150 Jahren? Finden Sie es mit unserem interaktiven Tool heraus.',
    pubDate: 'Publiziert am 20. Februar 2024',
  },
  calculator: {
    title: 'Ihre Angaben',
    subtitle: 'Vergleichen Sie sich mit der erwachsenen Schweizer Bevölkerung',
    inputHeight: 'Körpergrösse',
    inputGender: 'Geschlecht',
    button: 'Resultate unten ↓',
  },
  barchart: {
    title: 'So gross sind Sie im Vergleich mit Schweizer', //... Männern / Frauen
    today: 'Heute',
    you: 'Sie',
    yLabelm: '% der Männer',
    yLabelw: '% der Frauen',
  },
  linechartCanton: {
    title: 'Die Schweizer Rekruten wurden immer grösser',
    subtitle:
      'Entwicklung der durchschnittlichen Körpergrösse der Stellungspflichtigen im Alter von 18 bis 21, ausgewählte Kantone und Schweiz, 1890–2022',
  },
  linechartCountry: {
    title: 'Männer in der Schweiz sind ähnlich gross wie in Italien',
    subtitle:
      'Entwicklung der durchschnittlichen Körpergrösse ausgewählter Länder, 1914–2014',
    keys: {
      Schweiz: 'Schweiz',
      Frankreich: 'Frankreich',
      Niederlande: 'Niederlande',
      Italien: 'Italien',
      USA: 'USA',
    },
  },
  map: {
    title:
      'In Basel die Grössten, im Tessin die Kleinsten: Grössenunterschiede der Rekruten in der Schweiz',
    subtitle:
      'Abweichung zur Schweizer Durchschnittsgrösse der Stellungspflichtigen nach PLZ, 2010 bis 2012',
    legend: 'Abweichung der Männer vom CH-Schnitt:',
    annotation: {
      AI: 'Die <b>Innerrhoder</b> sind im Schnitt mehr als <b>0,75 cm</b> kleiner als der Schweizer Durchschnitt',
      ZH: 'In reicheren Gegenden, wie der <b>Goldküste</b>, liegen die Körpergrössen weiterhin über dem Schweizer Schnitt',
      VS: 'Im deutschsprachigen <b>Oberwallis</b> sind die Männer grösser als im <b>Unterwallis</b>',
    },
  },
  tableCountry: {
    title: 'Niederländer und Lettinnen sind die Grössten',
    subtitle: 'Durchschnittliche Grösse von Frauen und Männern nach Ländern',
  },
  sources: {
    healthSurvey: 'Grafik: cos; Quelle: Modell. Gesundheitbefragung 2017',
    smw: 'Grafik: cos; Quelle: Swiss Medical Weekly 2011;141',
    smvAjb:
      'Grafik: pvo; Quelle: Swiss Med Weekly 2011;141, American Journal of Biology 2022;34',
    ncdRisk: 'Grafik: pvo; Quelle: NCD RisC (2016)',
    uzh: 'Karte: pvo; Quelle: Universität Zürich, «A tall order» 2017',
  },
}

const fr: typeof de = {
  man: 'Homme',
  woman: 'Femme',
  men: 'Hommes',
  women: 'Femmes',
  men_gen: 'hommes suisses',
  women_gen: 'femmes suisses',
  header: {
    title: 'Quelle taille faites-vous par rapport aux autres?',
    lead: 'Combien de personnes en Suisse sont plus grandes, combien sont plus petites? Et comment était-ce il y a 150 ans? Notre outil interactif a la réponse.',
    pubDate: 'Publié le 28 février 2024',
  },
  calculator: {
    title: 'Vos données',
    subtitle: 'Comparez-vous à la population suisse adulte',
    inputHeight: 'Taille',
    inputGender: 'Genre',
    button: 'Résultats ci-bas ↓',
  },
  barchart: {
    title: 'Votre taille par rapport aux', //... hommes suisses / femmes suisses
    today: "Aujourd'hui",
    you: 'Vous',
    yLabelm: '% des hommes',
    yLabelw: '% des femmes',
  },
  linechartCanton: {
    title: 'Les recrues suisses sont devenues de plus en plus grandes',
    subtitle:
      'Évolution de la taille moyenne des conscrits âgés de 18 à 21 ans, cantons sélectionnés et Suisse, 1890-2022',
  },
  linechartCountry: {
    title: "Les hommes en Suisse sont aussi grands qu'en Italie",
    subtitle:
      'Évolution de la taille moyenne dans une sélection de pays, 1914-2014',
    keys: {
      Schweiz: 'Suisse',
      Frankreich: 'France',
      Niederlande: 'Pays-Bas',
      Italien: 'Italie',
      USA: 'USA',
    },
  },
  map: {
    title:
      'Les plus grands vivent à Bâle, les plus petits au Tessin: différences de taille des recrues en Suisse',
    subtitle:
      'Écart par rapport à la taille moyenne suisse des conscrits par NPA, 2010 à 2012',
    legend: 'Écart des hommes par rapport à la moyenne CH:',
    annotation: {
      AI: "Les habitants d'<b>Appenzell Rhodes-Intérieures</b> sont en moyenne <b>0,75 cm</b> plus petits que la moyenne suisse",
      ZH: 'Dans les régions plus riches, comme la <b>Goldküste</b>, les tailles restent supérieures à la moyenne suisse',
      VS: 'Dans le <b>Haut-Valais</b> alémanique, les hommes sont plus grands que dans le <b>Bas-Valais</b>',
    },
  },
  tableCountry: {
    title: 'Les Lettones et les Néerlandaises sont les plus grandes',
    subtitle: 'Taille moyenne des femmes et des hommes par pays',
  },
  sources: {
    healthSurvey: 'Graphique: cos; Source: Modèle. Enquête sur la santé 2017',
    smw: 'Graphique: cos; Source: Swiss Medical Weekly 2011;141',
    smvAjb:
      'Graphique: pvo; Source: Swiss Med Weekly 2011;141, American Journal of Biology 2022;34',
    ncdRisk: 'Graphique: pvo; Source: NCD RisC (2016)',
    uzh: 'Carte: pvo; Source: Université de Zurich, «A tall order» 2017',
  },
}

export { de, fr }
